export default `<?xml version="1.0" encoding="UTF-8"?>
<svg width="96px" height="96px" viewBox="0 0 96 96" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <title>splash-1</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Coriolis" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Wizard/03-Instances---Search-Error" transform="translate(-672.000000, -336.000000)" stroke="#F91661" stroke-width="1.5">
            <g id="Splash-Copy" transform="translate(501.000000, 336.000000)">
                <g id="Icon/Error/Red-96" transform="translate(171.000000, 0.000000)">
                    <circle class="circle" cx="48" cy="48" r="47"></circle>
                    <path class="path" d="M68.5714286,27.4285714 L27.4285714,68.5714286" id="Line"></path>
                    <path class="path" d="M68.5714286,68.5714286 L27.4285714,27.4285714" id="Line-Copy"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`;
